/* Native disclosure navigation (mobile menu, poster panel): close on Escape, link activation and outside clicks;
   on hover-capable screens the poster panel also opens on hover. */
(() => {
  const OPEN = '.nl-menu[open], .nl-drop[open]';
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    for (const menu of document.querySelectorAll(OPEN)) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', (event) => {
    for (const menu of document.querySelectorAll(OPEN)) {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    }
  });
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  for (const drop of document.querySelectorAll('.nl-drop')) {
    let timer;
    const header = drop.closest('.nl-hdr') || drop;
    drop.addEventListener('mouseenter', () => { clearTimeout(timer); drop.open = true; });
    /* Hover already opened it: a click must not toggle it shut again under the pointer. */
    drop.querySelector('summary').addEventListener('click', (event) => {
      if (drop.matches(':hover')) { event.preventDefault(); drop.open = true; }
    });
    header.addEventListener('mouseleave', () => { timer = setTimeout(() => { drop.open = false; }, 180); });
    header.addEventListener('mouseenter', () => clearTimeout(timer));
    for (const sibling of header.querySelectorAll('.nl-hdr__desktop > a')) {
      sibling.addEventListener('mouseenter', () => { drop.open = false; });
    }
  }
})();
